module.exports = __webpack_public_path__ + "img/未授权账号.7d829f6a.png";